import { Component, OnInit, ContentChild, TemplateRef, Input } from '@angular/core';

@Component({
  selector: 'zx-header-block',
  templateUrl: './header-block.component.html',
  styleUrls: [ './header-block.component.css' ]
})
export class HeaderBlockComponent implements OnInit {

	@Input() showBreadcrumb: boolean = true;
	@Input() showBottomLine: boolean = true;
	@Input() breadcrumbAppendings: any[];

	@Input() icon: string;
	@Input() iconClass: string;
	@Input() title: string;
	@Input() showBackAction: boolean = false;

	@ContentChild('icon', {static:true}) tpl_icon: TemplateRef<void>;
	@ContentChild('title', {static:true}) tpl_title: TemplateRef<void>;
	@ContentChild('operations', {static:true}) tpl_operations: TemplateRef<void>;
	@ContentChild('breadcrumbExtra', {static:true}) tpl_breadcrumbExtra: TemplateRef<void>;
	@ContentChild('contentExtra', {static:true}) tpl_contentExtra: TemplateRef<void>;

    constructor() { }
	ngOnInit() { }
	
	goBack(){
		history.back();
	}
}